export default __webpack_public_path__ + "static/media/polgot-mobile-2.5b9d72ad.png";